import { render, staticRenderFns } from "./batchFinanceModel.vue?vue&type=template&id=8c2d3c54&scoped=true&"
import script from "./batchFinanceModel.vue?vue&type=script&lang=js&"
export * from "./batchFinanceModel.vue?vue&type=script&lang=js&"
import style0 from "./batchFinanceModel.vue?vue&type=style&index=0&id=8c2d3c54&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c2d3c54",
  null
  
)

export default component.exports